import { render, staticRenderFns } from "./pre-define.vue?vue&type=template&id=10dccdf5&"
import script from "./pre-define.vue?vue&type=script&lang=js&"
export * from "./pre-define.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports